const ENCLOSED_FEE = 'ENCLOSED';
const INOP_FEE = 'INOP';
const DEPOSIT_FEE = 'DEPOSIT_FEE';
const SIZE_FEE = 'SIZE';

export const DISTANCE_FEE_TYPES = {
  enclosed: ENCLOSED_FEE,
  inop: INOP_FEE,
  deposit: DEPOSIT_FEE,
  size: SIZE_FEE
};
